module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "html.worker.b6f9a4dba9ee0aa76de0.js");
}
